export function dispatchThunk(store, thunkAction) {
  //see https://github.com/reduxjs/redux-thunk/issues/135
  store.dispatch(thunkAction);
}